<template>
  <div class="custom-wrapper z-nopadd" :class="{active: visible}">
    <div class="position: relative;">
      <!-- .custom-company-cooperation === ccc -->
      <div class="ccc">
        <!-- 设置内容 -->
        <div class="cccp-content">
          <div style="margin-bottom:30px;margin-left:5px;">云店Logo设置</div>
          <!-- <div style="word-break: break-all; white-space: pre-wrap;" v-if="uploadList && uploadList[0]">{{uploadList[0].url}}</div> -->
          <div class="my-upload">
            <div class="my-upload-list" v-for="(item, index) in uploadList" :key="'upload' + index">
              <template v-if="item.status === 'finished'">
                <img :src="item.url" style="width: 100px;height:100px;" />
                <div class="my-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                  <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                </div>
              </template>
              <template v-else>
                <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                  <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                </Spin>
              </template>
            </div>
            <Upload
              ref="upload"
              :show-upload-list="false"
              :default-file-list="defaultList"
              :on-success="handleSuccess"
              :format="['jpg','jpeg','png']"
              :max-size="2048"
              :headers="formHeaders"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize"
              type="drag"
              :action="uploadUrl"
              multiple
              :before-upload="handleBeforeUpload"
              style="display: inline-block;width:100px;"
              v-show="uploadList && uploadList.length <1"
            >
              <div style="width: 100px;height:100px;padding-top: 17px;">
                <div style="font-size:20px">
                  +
                  <p style="font-size:14px">上传</p>
                </div>
              </div>
              <!-- 蒙版 -->
              <div
                style="position:absolute;opacity:0;width:100px;height:100px;left:0;top:0;"
                @click.stop="selectType"
              ></div>
            </Upload>
          </div>
          <div class="my-upload-tip">（图片要求：2M以下的jpg或png，建议尺寸为100*100px）</div>
        </div>
      </div>
    </div>

    <iModal title="图片查看" cancel-text v-model="visible2">
      <div style="text-align: center;">
        <img :src="imgName" v-if="visible2" style="max-width: 100%" />
      </div>
    </iModal>

    <!-- 选择文件上传方式 -->
    <imgUpload
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      :maxCount="1"
      v-model="uploadChooseShowed"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import popper from "@components/vue-popper-new/VuePopperNew.vue";
import imgUpload from "@components/imgUpload/imgUpload.vue"; 

export default {
  // 顶部banner
  name: "custom-company-header",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    Modal: {
      type: Object,
      default: function() {
        return null;
      }
    }
  },
  data() {
    return {
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
      visible: false,

      imgName: "",
      defaultList: [],
      visible2: false,
      uploadList: []
    };
  },
  watch: {
    activeIndex(val, oldVal) {
      // if (val !== this.index) this.visible = false;
    },
    save(val, oldVal) {
      if (val) {
        this.handleSubmit();
        this.visible = false;
      }
    }
  },
  computed: {
    ...mapGetters({
      activeIndex: "customCompanyModule/getActiveIndex",
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      save: "customCompanyModule/getSave"
    }),
    type() {
      return this.Modal.config.type;
    }
  },
  mounted() {
    if (this.$refs.upload) {
      if(this.$refs.upload.fileList) {

      }
      this.uploadList = this.$refs.upload.fileList; 
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapMutations({
      setCompany: "loginModule/setCompany",
      setActiveIndex: "customCompanyModule/setActiveIndex"
    }),
    ...mapActions({
      getCompanyById: "loginModule/getCompanyById",
      editCompanyUpdate: "companyModule/editCompanyUpdate"
    }),
    init() {

      if(this.company.logo) {
        this.defaultList = [
          {
            name: this.company.name,
            url: this.company.logo,
            status: "finished",
            percentage: 100
          }
        ];
        this.$emit("sendModal", { logo: this.company.logo });
        this.uploadList = this.defaultList; 
      } else {
        this.uploadList = [];
      }
    },
    // 选择图片上传方式
    selectType() {
      this.uploadChooseShowed = true;
    },
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    // 拦截上传方法
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList.length >= 1) {
          this.$Message.warning(`最多上传1张图片`);
          return;
        } else {
          this.uploadList.push({
            status: "finished",
            url: item
          });
          this.$emit("sendModal", { logo: item });
          this.uploadChooseShowed = false;
        }
      }
    },
    // 上传图片
    handleView(name) {
      this.imgName = name;
      this.visible2 = true;
    },
    handleRemove(file) {
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList = [];
      this.defaultList = [];
      this.uploadList = [];
      this.$emit("sendModal", { logo: "" });
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
        this.$emit("sendModal", { logo: this.uploadList[0].url }); 
      }
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "文件格式是不正确的",
        desc: "请上传jpg或者png格式的图片"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "文件大小超过限制",
        desc: "请上传小于2M的图片"
      });
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `最多上传${limitNum}张图片`
        });
      }
      return check;
    },
    async handleSubmit(name) {
      let logo = "";
      if (this.uploadList && this.uploadList.length) {
        logo = this.uploadList[0].url;
      } else {
        this.$Message.error("请上传公司logo");
        return;
      }
      let req = {
        Id: this.company.id,
        SetValues: {
          Logo: logo
        }
      };
      const bool = await this.editCompanyUpdate(req);
      if (!bool) {
        return false;
      }
      if (bool.errors && bool.errors[0]) {
        this.$Message.error(bool.errors[0].description);
        return;
      }
      let company = await this.getCompanyById(this.company.id);
      this.setCompany(company);
      this.init();
    }
  },
  components: {
    popper,
    imgUpload
  }
};
</script> 
<style scoped lang="scss">
.ccc {
  width: 100%;
  &-info {
    display: inline-block;
    padding-left: 40px;
    font-size: 14px;
    color: #808080;
  }
  &-box {
    font-size: 0;
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  .cccp {
    &-title {
      padding: 20px 30px;
      font-size: 14px;
      color: #333;
      border-bottom: solid 1px #ddd;
    }
    &-content {
      padding: 40px 50px;
      .addlink {
        border: dashed 1px #bfbfbf;
        text-align: center;
        color: #1890ff;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.custom-wrapper {
  &.z-nopadd {
    padding: 0 0 10px;
  }
  &:hover,
  &.active {
    .custom-item {
      border: 1px solid #1890ff;
    }
  }
}
</style>
